// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2JM_O","productName":"Table_productName__2hcDx"};